import { render, staticRenderFns } from "./AutoCompleteCustomJobSearch.vue?vue&type=template&id=4d38d6fa&scoped=true"
import script from "./AutoCompleteCustomJobSearch.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteCustomJobSearch.vue?vue&type=script&lang=ts"
import style0 from "./AutoCompleteCustomJobSearch.vue?vue&type=style&index=0&id=4d38d6fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38d6fa",
  null
  
)

export default component.exports